import __request__ from "routing/request";
export function checkCredentials(JSONbody) {
  return __request__("POST", "/cloudtrail/check_credentials", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getAWSRegions() {
  return __request__("GET", "/cloudtrail/getawsregions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody, setup_wizard = false) {
  return __request__("POST", "/cloudtrail/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  });
}
